import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import BasicTooltip from './BasicTooltip'
import { Form, InputNumber } from 'antd'

const NumberInput = props => {
  const [showToolTip, setShowToolTip] = useState(false)
  const {
    toolTipLabel,
    inputType,
    label,
    name,
    value,
    required,
    handleChange,
    placeholder,
    className,
    min,
    max,
    disabled
  } = props

  useEffect(() => {
    toolTipLabel && setShowToolTip(true)
  }, [toolTipLabel])

  return (
    <React.Fragment>
      {/* <label for={name}>
          {props.label}
          {showToolTip ? <BasicTooltip label={props.toolTipLabel} /> : null}
        </label> */}

      <Form.Item
        name={name}
        label={
          <>
            {label ? label : ''}{' '}
            {showToolTip ? (
              <>
                <BasicTooltip label={toolTipLabel} />
              </>
            ) : (
              ''
            )}
          </>
        }
        initialValue={value}
        rules={[
          {
            required: required
          }
        ]}
        colon={false}
      >
        <InputNumber
          type={inputType}
          className={`form_input_muted ${className}`}
          id={name}
          min={min}
          max={max}
          value={value}
          defaultValue={value}
          onChange={handleChange}
          name={name}
          placeholder={placeholder}
          style={{ width: '100%' }}
          size="middle"
          disabled={disabled}
          // required={required}
        />
      </Form.Item>
    </React.Fragment>
  )
}

NumberInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  inputType: PropTypes.string,
  value: PropTypes.any,
  handleChange: PropTypes.func,
  placeholder: PropTypes.string,
  toolTipLabel: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  disabled: PropTypes.bool
}

export default NumberInput
